export function mergeBrandData(brandData: any[], rawTableData: any[]) {
  const mergedData: any[] = [];

  // Create a map for raw table data by brand_id
  const rawTableMap = rawTableData.reduce((acc, item) => {
    const brandId = item.brand_id;

    if (!acc[brandId]) {
      acc[brandId] = {
        tables: [],
        interface_name: item.interface_name,
        interface_id: item.interface_id,
      };
    }

    acc[brandId].tables.push({
      config_name: item.config_name,
      table_id: item.raw_output_table_name,
    });

    return acc;
  }, {} as Record<string, { tables: any[]; interface_name: string; interface_id: number }>);

  // Merge brand data with raw table data
  brandData.forEach((brand) => {
    const brandId = brand.brand_id;
    const rawInfo = rawTableMap[brandId] || {
      tables: [],
      interface_name: null,
      interface_id: null,
    };

    mergedData.push({
      ...brand,
      interface_name: rawInfo.interface_name,
      interface_id: rawInfo.interface_id,
      raw_output_table_name: rawInfo.tables,
    });
  });

  return mergedData;
}
